import UserDetails from '../models/UserDetails';
import { UserRoles } from '../models/UserRole';
import { UserTypes } from 'src/models/UserType';
import { isArray } from 'util';
import * as _ from 'lodash';

export default class Authorization {
    public static ShowElement(nav: JSX.Element, roles: UserRoles | Array<UserRoles>, types: UserTypes | Array<UserTypes>, user: UserDetails) {
        const inRole = roles ? (Authorization.IsInRole(roles, user) ? true : false) : true;
        const inType = types ? (Authorization.IsInType(types, user) ? true : false) : true;

        return inRole && inType ? nav : undefined;
    }

    public static IsInRole(roles: UserRoles | Array<UserRoles>, user: UserDetails) {
        if (isArray(roles)) {
            return _.includes(roles, user.role);
        } else {
            return user.role === roles;
        }
    }

    public static IsInType(types: UserTypes | Array<UserTypes>, user: UserDetails) {
        if (isArray(types)) {
            return _.includes(types, user.type);
        } else {
            return user.type === types;
        }
    }

    public static IsStaffed(tabName: string, projectId: number, user: UserDetails) {
        switch (tabName) {
            case 'Owners':
                let ownerProjects: string[] = user.ownershipAccess ? user.ownershipAccess.split(',') : [];
                if (ownerProjects.indexOf(ownerProjects.find(op => op === projectId?.toString())) > -1) {
                    return true;
                }
                return false;
            case 'Contracts':
                let contractProjects: string[] = user.contractAccess ? user.contractAccess.split(',') : [];
                if (contractProjects.indexOf(contractProjects.find(op => op === projectId?.toString())) > -1) {
                    return true;
                }
                return false;
            case 'Reports':
                let reportProjects: string[] = user.reportAccess ? user.reportAccess.split(',') : [];
                if (reportProjects.indexOf(reportProjects.find(op => op === projectId?.toString())) > -1) {
                    return true;
                }
                return false;
            case 'Mapping':
                return true;
            case 'Staffing':
            case 'Settings':
                return false;
            default:
                return false;
        }
    }

    public static JwtUserRole(role: string) {
        let userRole: UserRoles = undefined;

        switch (role) {
            case 'ad':
                userRole = UserRoles.Admin;
                break;
            case 'pm':
                userRole = UserRoles.ProspectManager;
                break;
            case 'pc':
                userRole = UserRoles.ProjectCoordinator;
                break;
            case 'ha':
                userRole = UserRoles.HRAdmin;
                break;
            case 'hr':
                userRole = UserRoles.HR;
                break;
            case 'aa':
                userRole = UserRoles.AccountingAdmin;
                break;
            case 'ac':
                userRole = UserRoles.Accounting;
                break;
            case 'lm':
                userRole = UserRoles.Landman;
                break;
            default:
                role = undefined;
        }

        return userRole;
    }

    public static JwtUserType(type: string) {
        let userType: UserTypes = undefined;

        switch (type) {
            case 'em':
                userType = UserTypes.Employee;
                break;
            case 'lm':
                userType = UserTypes.Landman;
                break;
            case 'cl':
                userType = UserTypes.ClientLandman;
                break;
            default:
                userType = undefined;
                break;
        }

        return userType;
    }
}



// WEBPACK FOOTER //
// ./src/util/Authorization.ts